module.exports = {
  1: { api: 1, human: 'reine Liebhabernutzung (ohne Vermietung)', gdv: 'O' },
  2: { api: 2, human: 'auch alltägliche Nutzung (ohne Vermietung)', gdv: 'O' },
  3: { api: 3, human: 'Chauffeur-Vermietung', gdv: 'F' },
  4: { api: 4, human: 'Selbstfahrervermietung', gdv: 'F' },
  5: { api: 5, human: 'Sonstige Nutzung (ohne Vermietung)', gdv: 'O' }
}

// gdv nach GDV Gesamtverfahrenshandbuch Seite 1501
